import React, { useMemo } from 'react';
import { View } from 'react-native';
import BoilerPlate from '../boilerPlate/BoilerPlate';
import { ButtonSizeDLS, ButtonTypeDLS, ColorTokens, IconSizeTokens, IconTokens, ImageSizeTokens, LottieSizeTokens, LottieTokens, TypographyTypeDLS } from '@voltmoney/schema';
import ButtonDLSBase from '../../button/ButtonDLS.base';
import Image from '../../image/Image';
import Typography from '../../typography/Typography';
import { LENDER_ID, UPDATE_REQUEST_TYPE, UPDATE_STATUS_TYPE } from '../constants';
import { Lottie } from "../../lottie/Lottie";
import Icon from '../../icon/Icon';
const UpdateDetailsScreen = ({ height, continueAction, triggerAction, result }) => {
    const status = result?.status;
    const lender = result?.lenderAccountId;
    const type = result?.requestType;
    const handleSubmit = async () => {
        await triggerAction(continueAction);
    };
    const footerChild = useMemo(() => {
        return (React.createElement(View, { style: { margin: 16 } },
            React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, typeDLS: ButtonTypeDLS.PRIMARY, label: (status === UPDATE_STATUS_TYPE.REQUESTED || status === UPDATE_STATUS_TYPE.SUCCESS) ? 'Got it' : 'Retry', onPress: handleSubmit, isDisabled: false })));
    }, [result]);
    const renderMobileInProgressContent = () => {
        return (React.createElement(View, { style: { alignItems: 'center', paddingHorizontal: 16 } },
            React.createElement(Image, { size: ImageSizeTokens.XL, uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/Mobile_inprogress.png' }),
            React.createElement(View, { style: { marginTop: 48 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H3S, label: 'Mobile number update requested', color: ColorTokens.Grey_Night })),
            React.createElement(View, { style: { marginTop: 8 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: 'The request will be processed in 1-3 business days.', color: ColorTokens.Grey_Charcoal })),
            React.createElement(View, { style: { marginTop: 16, borderRadius: 8, padding: 12, backgroundColor: '#F1F3F5' } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: 'Once updated, use the new mobile number to login to your account.', color: ColorTokens.Grey_Night }))));
    };
    const renderSuccessEmailContent = () => {
        return (React.createElement(View, { style: { alignItems: 'center', paddingHorizontal: 16 } },
            React.createElement(Lottie, { uri: LottieTokens.Enhance_Limit_Success, size: LottieSizeTokens.Size_96 }),
            React.createElement(View, { style: { marginTop: 48 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H3S, label: 'Email ID updated successfully', color: ColorTokens.Grey_Night }))));
    };
    const renderSuccessMobileContent = () => {
        return (React.createElement(View, { style: { alignItems: 'center', paddingHorizontal: 16 } },
            React.createElement(Lottie, { uri: LottieTokens.Enhance_Limit_Success, size: LottieSizeTokens.Size_96 }),
            React.createElement(View, { style: { marginTop: 48 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H3S, label: 'Mobile number updated successfully', color: ColorTokens.Grey_Night })),
            React.createElement(View, { style: { marginTop: 8, borderRadius: 8, padding: 12, backgroundColor: '#F1F3F5' } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: 'Use the new mobile number to login to your account.', color: ColorTokens.Grey_Charcoal }))));
    };
    const renderEmailInProgressContent = () => {
        return (React.createElement(View, { style: { alignItems: 'center', paddingHorizontal: 16 } },
            React.createElement(Image, { size: ImageSizeTokens.XL, uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/Mobile_inprogress.png' }),
            React.createElement(View, { style: { marginTop: 48 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H3S, label: 'Email ID update requested', color: ColorTokens.Grey_Night })),
            React.createElement(View, { style: { marginTop: 8 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: 'The request will be processed in 1-3 business days.', color: ColorTokens.Grey_Charcoal }))));
    };
    const renderFailedContent = () => {
        return (React.createElement(View, { style: { alignItems: 'center', paddingHorizontal: 16 } },
            React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_ERROR_DLS, size: IconSizeTokens.Size96 }),
            React.createElement(View, { style: { marginTop: 48 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H3S, label: 'Request failed', color: ColorTokens.Grey_Night })),
            React.createElement(View, { style: { marginTop: 8 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: 'There was an error updating your details. Please try again.', color: ColorTokens.Grey_Charcoal }))));
    };
    const renderContent = () => {
        if (lender?.toLowerCase() === LENDER_ID.TATA.toLowerCase() && status === UPDATE_STATUS_TYPE.SUCCESS) {
            if (type === UPDATE_REQUEST_TYPE.EMAIL) {
                return renderSuccessEmailContent();
            }
            else
                return renderSuccessMobileContent();
        }
        else if (status === UPDATE_STATUS_TYPE.REQUESTED) {
            if (type === UPDATE_REQUEST_TYPE.EMAIL) {
                return renderEmailInProgressContent();
            }
            else
                return renderMobileInProgressContent();
        }
        else
            return renderFailedContent();
    };
    return (React.createElement(BoilerPlate, { height: height, bottomChildren: footerChild, backgroundColor: ColorTokens.White, alignContentCenter: true },
        React.createElement(React.Fragment, null, renderContent())));
};
export default UpdateDetailsScreen;
